import type { FC } from 'react'
import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import ScaleImage from './ScaleImage'

const copy = {
  heading: `Scale you can trust`,
  description: `Twilio offers scale and connectivity to power all of your WhatsApp messaging, allowing marketers to focus on creating strong relationships with customers.`,
}

const boxes = [
  {
    headline: `You can trust Twilio to deliver a seamless WhatsApp experience`,
    content: `Twilio operates as one of the largest Business Service Providers in the WhatsApp partner ecosystem, with onboarding support, Professional Services and tools to help scale your WhatsApp use cases.`,
  },
  {
    headline: `Futureproof your WhatsApp and multichannel marketing`,
    content: `Build your marketing strategy on an exponentially extensible and easy-to-use developer-friendly platform that allows your team to integrate with the Marketing Technologies you use today, and will need to adopt in the years to come.`,
  },
  {
    headline: `Seamlessly integrate WhatsApp with Twilio`,
    content: `Easily create a WhatsApp Business Account with Twilio, an official WhatsApp Business Solutions Provider – without the need to pay for additional external developer resources every time you need to integrate a new channel.`,
  },
]

const Scale: FC = () => {
  return (
    <SectionBase variant="2Col" reverse={true}>
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
        <ColumnTrackWrapper>
          <ColumnTrack gap="medium">
            {boxes.map(({ headline, content }) => (
              <FeatureBoxBase alignment="left" key={headline}>
                <FeatureBox.Body>
                  <FeatureBox.Title>{headline}</FeatureBox.Title>
                  <FeatureBox.Text>{content}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
      </SectionCopy>
      <Section.Contents>
        <ScaleImage />
      </Section.Contents>
    </SectionBase>
  )
}

export default Scale

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

const SectionCopy = styled(Section.Copy)`
  max-width: 440px;
  direction: ltr;
`
